<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getProducts } from "../../api"

    import ProductListItem from "./ProductListItem.svelte"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { login, productListCache } from "../../store"
    import { equal } from "../../utils"

    export let filter: any

    export let sort: any
    export let limit = 8
    export let count = 0
    export let currentCount = 0

    let offset = 0
    let hasMore = false
    let loading = false

    export let products: Product[] = []

    const setProducts = (_products: ApiResult<Product[]>, append = true) => {
        if (append) {
            products = [...products, ..._products.data]
        } else {
            products = _products.data
        }
        count = _products.count
        currentCount = products.length
        hasMore = currentCount < count
        loading = false
    }

    const load = async () => {
        hasMore = false
        loading = true
        let _filterChanged = filterChanged

        // is dealer is logged in hide no_dealers products
        if ($login) {
            filter.no_dealers = {
                $ne: true,
            }
        }

        const cacheKey = JSON.stringify({ filter, sort })

        if (offset == 0) {
            // try to use cache
            let _p = $productListCache.get(cacheKey)
            if (_p) {
                setProducts(_p, false)
                offset = products.length - limit
                return
            }
        }

        const _products = await getProducts(filter, sort, limit, offset)
        if (filterChanged != _filterChanged) {
            // filter changed while query in progress, so ignore products
        } else {
            setProducts(_products)
            $productListCache.put(cacheKey, {
                data: products,
                count: _products.count,
            })
        }
    }
    const loadMore = async () => {
        offset = products.length // Set offset to the current length of the products array
        await load() // Load more products
    }
    let prevFilter: any
    let prevSort: any

    let filterChanged = 0

    $: {
        if (filter && sort && (!equal(prevFilter, filter) || prevSort != sort)) {
            count = 0
            offset = 0
            hasMore = false
            products = []
            if (filter && sort) {
                filterChanged++
                prevFilter = filter
                prevSort = sort
                load()
            }
        }
    }
    $: hasMore = count > currentCount

    $: if (count && currentCount) {
        hasMore = currentCount < count
    }
</script>

<!-- Product List -->
<div class="products">
    {#each products as product (product.id)}
        <ProductListItem {product} />
    {/each}
</div>

<!-- Load more Button -->
{#if hasMore}
    <div class="center_btn">
        <button class="btn btn-secondary" on:click="{loadMore}">
            {$_("product.load-more")}
        </button>
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    .products {
        display: grid;
        grid-gap: 20px;
        margin-left: -15px;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }

    .center_btn {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        button {
            padding: 10px 30px;
        }
    }
    @media (min-width: @res-mobile) {
        .products {
            grid-template-columns: 1fr;
        }
    }

    @media (min-width: @res-tablet) {
        .products {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        }
    }
    @media (min-width: @res-desktop) {
        .products {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        }
    }
</style>
